import type { BoxProps } from '@mui/material';
import { Box, List, ListItemText } from '@mui/material';

import type { ReactNode } from 'react';

import { StyledNavItem, StyledNavItemIcon } from './styles';
import { NavIcon } from "../../layouts/main/nav/NavIcon";
import useAuth from "../../hooks/useAuth";
import { THEN_DO_NOTHING } from "../../utils/callbacks";

export type NavItemConfig = {
    title: string;
    path: string;
    icon?: ReactNode;
    info?: ReactNode;
};

export type NavSectionProps = {
    data?: NavItemConfig[];
    sx?: BoxProps['sx'];
};

export default function NavSection({ data = [], ...other }: NavSectionProps) {
    let logout: NavItemConfig = {
        title: 'Logout',
        path: '/login',
        icon: <NavIcon name="logout"/>,
    };

    const auth = useAuth();

    return (
        <Box { ...other }>
            <List disablePadding sx={ { display: 'flex', flexDirection: 'column', gap: 0.5 } }>
                { data.map((item) => (
                    <NavItem key={ item.title } item={ item }/>
                )) }

                <NavItem item={ logout } onClick={ () => auth.logout(THEN_DO_NOTHING) }/>
            </List>
        </Box>
    );
}

type NavItemProps = {
    item: NavItemConfig;
    onClick?: () => void;
};

function NavItem({ item, onClick }: NavItemProps) {
    const { title, path, icon, info } = item;

    return <StyledNavItem
        to={ path }
        sx={ {
            '&.active': {
                color: '#1A55B3',
                bgcolor: '#E8F0FC',
                fontWeight: 700,
            },
        } }
        onClick={ onClick || (() => {
        }) }
    >
        <StyledNavItemIcon>{ icon && icon }</StyledNavItemIcon>

        <ListItemText disableTypography primary={ title }/>

        { info && info }
    </StyledNavItem>;
}
